import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import locales from '../../../content.json';

import puppyYoungAvif from './img/bg.avif';
import puppyYoungJpg from './img/bg.jpg';
import puppyAdultAvif from './img/bg2.avif';
import puppyAdultJpg from './img/bg2.jpg';

import puppyYoungIlustrAvif from './img/bgIlustr.avif';
import puppyYoungIlustrJpg from './img/bgIlustr.jpg';
import puppyAdultIlustrAvif from './img/bg2Ilustr.avif';
import puppyAdultIlustrJpg from './img/bg2Ilustr.jpg';

import {
  analyticsEventsTracker,
  GTMOnboardingFunnelEvent,
  EVENT_TRACKERS,
} from '../../../utils/analytics';

import { getParameterFromURL } from '../../../utils/scripts';
import s from './index.module.scss';

const AGE_YOUNG_PUPPY = ['0-6m', '7-12m'];

export const MainScreenPuppy = () => {
  const puppyBlues = useSelector(state => state.data.puppyBlues);
  const isUKSubscription = Boolean(getParameterFromURL('subscrUK'));
  const puppyAge = getParameterFromURL('ageValue');
  const isYoungPuppy = AGE_YOUNG_PUPPY.includes(puppyAge);
  const config = getParameterFromURL('config');
  const useIlustrImages = config === 'customV67' || config === 'customV68';

  const paywallVersion = isUKSubscription ? 'version2UK' : 'version2';

  const headerText = puppyBlues
    ? locales[window.userLang][
        isYoungPuppy ? 'payment_text_336' : 'payment_text_337'
      ]
    : locales[window.userLang].payment_text_218;
  const subtitleText =
    puppyBlues && !isYoungPuppy
      ? locales[window.userLang].payment_text_292
      : locales[window.userLang].payment_text_219;

  const heroImage = useMemo(() => {
    if (useIlustrImages) {
      return {
        avif: isYoungPuppy ? puppyYoungIlustrAvif : puppyAdultIlustrAvif,
        jpg: isYoungPuppy ? puppyYoungIlustrJpg : puppyAdultIlustrJpg,
      };
    }
    return {
      avif: isYoungPuppy ? puppyYoungAvif : puppyAdultAvif,
      jpg: isYoungPuppy ? puppyYoungJpg : puppyAdultJpg,
    };
  }, [isYoungPuppy, useIlustrImages]);

  useEffect(() => {
    analyticsEventsTracker.trackWithTarget(
      GTMOnboardingFunnelEvent.showPaywall(paywallVersion),
      EVENT_TRACKERS.GTM,
    );
  }, [paywallVersion]);

  return (
    <div className={s.container}>
      <h2 className={s.title}>{headerText}</h2>

      <p
        className={s.subtitle}
        dangerouslySetInnerHTML={{ __html: subtitleText }}
      />

      <picture className={s.heroImage}>
        <source srcSet={heroImage.avif} type="image/avif" />
        <img src={heroImage.jpg} alt="Puppy training preview" />
      </picture>
    </div>
  );
};
